import { render, staticRenderFns } from "./SelfServiceConfiguration.vue?vue&type=template&id=496ee372&scoped=true&"
import script from "./SelfServiceConfiguration.vue?vue&type=script&lang=js&"
export * from "./SelfServiceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceConfiguration.vue?vue&type=style&index=0&id=496ee372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ee372",
  null
  
)

export default component.exports